<template>
  <div
    class="ebnormalenergyWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="ebnormalenergyContent">
      <div class="tabListBox">
        <TabsCom :tabList="menuList" @getTabsActive="getTabsActive" />
      </div>
      <div class="centerBox">
        <div class="leftTree commonWrap">
          <RegionTreeCom @getActiveTree="getActiveTree" />
        </div>
        <div class="rightData">
          <div class="lineBox commonWrap">
            <div class="commonTitle">
              <h4></h4>
              <div style="margin-right: 20px">
                <el-radio-group
                  v-model="showTime"
                  size="mini"
                  style="margin-right: 20px"
                  @change="getLineData"
                >
                  <el-radio-button label="month">月</el-radio-button>
                  <el-radio-button label="year">年</el-radio-button>
                </el-radio-group>
                <el-button
                  type="primary"
                  v-if="authority"
                  size="mini"
                  plain
                  autofocus
                  @click="exportExcel"
                  ><i class="el-icon-download el-icon--left"></i
                  >EXCEL</el-button
                >
              </div>
            </div>
            <div class="commonContentBox">
              <PublicEcharts
                :id="'myCharts'"
                :chartsData="chartsData"
                :type="'lightLine'"
              />
            </div>
          </div>
          <div class="tabBox commonWrap">
            <div style="width: 95%; height: 90%; margin: 20px auto 10px">
              <el-table
                :data="tableList"
                height="85%"
                stripe
                style="width: 100%"
                size="mini"
                :header-cell-style="{
                  'font-weight': 'bold',
                  color: '#333',
                  'background-color': '#F7F7F7',
                }"
              >
                <el-table-column
                  v-for="(v, i) in tableHead"
                  :key="i"
                  :prop="v.prop"
                  :label="v.label"
                  :min-width="flexWidth(v.prop, tableList, v.label)"
                  :show-overflow-tooltip="true"
                  align="center"
                ></el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 30, 50]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.total"
                style="text-align: right; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  formatMinutes,
  judgeAuthority,
  flexWidth,
} from "@/assets/js/utils";
import { handleExportAuthority } from "@/assets/utils/handleData.js";
import RegionTreeCom from "@/components/nengyuanguanli/RegionTreeCom";
import PublicEcharts from "@/components/PublicEcharts";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import TabsCom from "@/components/nengyuanguanli/TabsCom.vue";
export default {
  components: {
    RegionTreeCom,
    PublicEcharts,
    TabsCom,
  },
  data() {
    return {
      authority: false,
      menuList: [
        { name: "异常时间用能", key: "time" },
        { name: "超功率用能", key: "power" },
      ],
      activeMenu: 0,
      showTime: "month",
      chartsData: {
        title: "",
        unit: "个",
        xData: [],
        dataArr: [{ name: "异常数量", data: [] }],
      },
      tableHead: [],
      tableList: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      treeActive: "",
      treeData: {},
    };
  },
  methods: {
    flexWidth,
    getTabsActive(val) {
      this.activeMenu = val.index;
    },
    getActiveTree(data) {
      this.treeActive = data.treeActive;
      this.treeData = data.treeData;
      this.currentPage = 1;
      this.page.page = 10;
      this.getTableList();
      this.getLineData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableList();
    },
    async getTableList() {
      this.getTabHead();
      this.tableList = [];
      let res = await api.energyAbnormalTable({
        assetId: this.treeActive,
        type: this.menuList[this.activeMenu].key,
        label: "区域位置",
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.data.code == 200) {
        this.page.total = res.data.data.totalElements;
        this.tableList = Array.from(res.data.data.data).map((item) => ({
          name: item.name,
          loadPower: item.loadPower,
          time: `${
            item.beginTs
              ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(item.beginTs))
              : ""
          } - ${
            item.endTs
              ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(item.endTs))
              : ""
          }`,
          maxPower: item.maxPower ? item.maxPower : "",
          duration: item.dayTime ? formatMinutes(item.dayTime) : "",
          monthDuration: item.monthTime ? formatMinutes(item.monthTime) : "",
          yearDuration: item.yearTime ? formatMinutes(item.yearTime) : "",
        }));
      }
    },
    getTabHead() {
      this.tableHead = [];
      if (this.menuList[this.activeMenu].key == "time") {
        this.tableHead = [
          { label: "区域名称", prop: "name" },
          { label: "额定功率/kW", prop: "loadPower" },
          { label: "最近异常用能时间", prop: "time" },
          { label: "异常用能时长", prop: "duration" },
          { label: "本月异常用能时长", prop: "monthDuration" },
          { label: "本年异常用能时长", prop: "yearDuration" },
        ];
      } else if (this.menuList[this.activeMenu].key == "power") {
        this.tableHead = [
          { label: "区域名称", prop: "name" },
          { label: "额定功率/kW", prop: "loadPower" },
          { label: "最近超功率用能时间", prop: "time" },
          { label: "最近最大功率/kw", prop: "maxPower" },
          { label: "超功率用能时长", prop: "duration" },
          { label: "本月超功率用能时长", prop: "monthDuration" },
          { label: "本年超功率用能时长", prop: "yearDuration" },
        ];
      }
    },
    async getLineData() {
      this.$store.commit("SET_LOADING", true);
      let res = await api.energyAbnormalLineData({
        assetId: this.treeActive,
        range: this.showTime,
        label: "区域位置",
        type: this.menuList[this.activeMenu].key,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.chartsData.xData = [];
        this.chartsData.dataArr[0].data = [];
        res.data.data.map((v) => {
          this.chartsData.xData.push(
            this.showTime == "month"
              ? dateFtt("yyyy-MM-dd", new Date(v.ts))
              : dateFtt("yyyy-MM", new Date(v.ts))
          );
          this.chartsData.dataArr[0].data.push(v.chartParamsList[0].value);
        });
      }
    },
    exportExcel() {
      let th = ["时间"];
      th.push(`${this.treeData.name}(次)`);
      let content = [];
      for (let i = 0; i < this.chartsData.xData.length; i++) {
        let row = [];
        row.push(this.chartsData.dataArr[0].data[i]);
        row.unshift(this.chartsData.xData[i]);
        content.push(row);
      }
      exportFile.xlsxFile(
        XLSX,
        `${this.treeData.name}(${this.menuList[this.activeMenu].name}-${
          this.showTime == "month" ? "本月统计" : "本年统计"
        })`,
        {
          异常用能数量: [th, ...content],
        }
      );
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.ebnormalenergyWrap {
  .ebnormalenergyContent {
    @include setPage;
    @include setFlexColumn;
    justify-content: space-between;
    .tabListBox {
      width: 100%;
      height: 10%;
    }
    .centerBox {
      width: 100%;
      height: calc(90% - 12px);
      @include setFlexBetween;
      .leftTree {
        width: 20%;
        height: 100%;
      }
      .rightData {
        width: calc(80% - 12px);
        height: 100%;
        @include setFlexColumn;
        justify-content: space-between;
        .lineBox {
          width: 100%;
          height: $halfWidth;
        }
        .tabBox {
          width: 100%;
          height: $halfWidth;
        }
      }
    }
  }
}
</style>
